module.exports = __webpack_public_path__ + "static/img/news58_6.8888459.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/Information/news58/news58_6.gif
// module id = B5zx
// module chunks = 0